"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconResetFilled = function IconResetFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.24184 3.71267C4.22053 4.30232 3.48024 5.25459 3.12164 6.3714L3.10991 6.41316L2.73112 5.75708C2.56446 5.4684 2.1862 5.37187 1.89056 5.54256C1.59492 5.71325 1.48939 6.08909 1.65606 6.37777L2.86818 8.47722C3.03485 8.7659 3.4131 8.86243 3.70874 8.69174L5.59011 7.60554C5.88575 7.43485 5.99128 7.059 5.82461 6.77033C5.65794 6.48165 5.27969 6.38512 4.98405 6.55581L4.2315 6.99029C4.2398 6.88053 4.29013 6.78149 4.31358 6.69797C4.56323 5.889 5.09536 5.19688 5.8479 4.7624C7.43363 3.84688 9.45098 4.36173 10.3449 5.91007C10.7995 6.69737 10.9046 7.68639 10.5895 8.56815C10.3247 9.35087 9.78912 9.97499 9.09033 10.3784C8.28403 10.844 7.37654 10.948 6.52083 10.7072C6.1846 10.6214 5.86208 10.8076 5.75313 11.1155C5.65933 11.4496 5.84115 11.7645 6.15049 11.8658C7.34243 12.1924 8.60617 12.0226 9.68124 11.4019C10.6488 10.8433 11.3925 9.95904 11.7394 8.88399C12.1483 7.66815 12.026 6.33911 11.3897 5.2369C10.1927 3.16369 7.41885 2.45577 5.24184 3.71267Z",
    fill: color
  }));
};

IconResetFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconResetFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconResetFilled;
exports.default = _default;